"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHouseCategory = void 0;
var React = __importStar(require("react"));
var IconHouseCategory = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M21,16.5 L21,10.999 C21,9.48 19.868,9.115 19.307,9.026 L16.935,14.147 C16.677,14.677 16.159,15 15.581,15 L7.504,15 C6.843,15 6.25,14.557 6.064,13.921 L4.636,9.036 C4.051,9.138 3,9.526 3,10.999 L3,16.5 C3,17.625 3.923,18.999 5,18.999 L19,18.999 C20.077,18.999 21,17.625 21,16.5 Z M11,3 C7.988,3 5.537,5.435 5.503,8.438 L7.023,13.64 C7.086,13.852 7.283,14 7.504,14 L15.581,14 C15.774,14 15.946,13.893 16.031,13.719 L18.495,8.4 C18.44,5.414 15.998,3 13,3 L11,3 Z M19.477,8.041 C20.544,8.209 22,8.953 22,10.999 L22,16.5 C22,18.108 20.705,19.972 19.03,19.995 L19.03,21.5 C19.03,21.776 18.807,22 18.53,22 C18.254,22 18.03,21.776 18.03,21.5 L18.03,19.999 L6,19.999 L6,21.5 C6,21.776 5.776,22 5.5,22 C5.224,22 5,21.776 5,21.5 L5,19.999 C3.311,19.999 2,18.118 2,16.5 L2,10.999 C2,9.452 2.83,8.713 3.526,8.364 C3.888,8.185 4.248,8.093 4.523,8.047 C4.757,4.675 7.569,2 11,2 L13,2 C16.429,2 19.239,4.671 19.477,8.041 Z M9,6.5 C8.725,6.5 8.5,6.276 8.5,6 C8.5,5.724 8.725,5.5 9,5.5 C9.276,5.5 9.5,5.724 9.5,6 C9.5,6.276 9.276,6.5 9,6.5 Z M15,6.5 C14.725,6.5 14.5,6.276 14.5,6 C14.5,5.724 14.725,5.5 15,5.5 C15.276,5.5 15.5,5.724 15.5,6 C15.5,6.276 15.276,6.5 15,6.5 Z M9,11.5 C8.725,11.5 8.5,11.276 8.5,11 C8.5,10.724 8.725,10.5 9,10.5 C9.276,10.5 9.5,10.724 9.5,11 C9.5,11.276 9.276,11.5 9,11.5 Z M15,11.5 C14.725,11.5 14.5,11.276 14.5,11 C14.5,10.724 14.725,10.5 15,10.5 C15.276,10.5 15.5,10.724 15.5,11 C15.5,11.276 15.276,11.5 15,11.5 Z M12,9 C11.725,9 11.5,8.776 11.5,8.5 C11.5,8.224 11.725,8 12,8 C12.276,8 12.5,8.224 12.5,8.5 C12.5,8.776 12.276,9 12,9 Z" }))); };
exports.IconHouseCategory = IconHouseCategory;
exports.IconHouseCategory.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconHouseCategory;
